// extracted by mini-css-extract-plugin
export default {"image":"AddProfileModal___style-module__image___-bUm7","list":"AddProfileModal___style-module__list___cJZA6"};